
import { Component, Prop, FormComponentBase } from "@/lib";

@Component({ name: "single-user-select" })
export default class SingleUserSelect extends FormComponentBase {
  @Prop({ type: [String, Number, Array], default: "", required: true })
  value: any;
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  selectList: Array<any>;
  @Prop({ type: Boolean, default: false }) number: boolean;
  @Prop({ type: Boolean, default: false }) labelInValue: boolean;
  @Prop({ type: Boolean, default: true }) clearable: boolean;
  @Prop({ type: Boolean, default: false }) transfer: boolean;

  data: any = {
    rangeNumber: 10,
    filterUserList: [],
    filterWord: "",
  };

  get requiredRule() {
    return {
      required: true, //是否必填
      type: this.number ? "number" : "string",
      message: this.L("Validate.PleaseSelect", this.L(this.labelKey)), //验证信息
      trigger: "change", //触发方式    常用  blur 和 change}
    };
  }

  get displayUserList() {
    if (this.data.filterWord) {
      return this.data.filterUserList.slice(0, this.data.rangeNumber);
    }

    if(this.value) {
      return this.selectList.filter(item => item.value === this.value);
    }

    if (!this.selectList || this.selectList.length === 0) {
      return [];
    }
    
    if (this.selectList && this.selectList.length) {
      return this.selectList.slice(0, this.data.rangeNumber);
    }
    return [];
  }

  mounted() {
    this.$nextTick(() => {
      let selection = this.$refs.remoteSelect as any;
      selection.validateOption = () => true;
    });
  }

  //防抖
  Debounce(func, wait = 500, immediate = false) {
    let timeout;
    // 清除定时器
    if (timeout !== null) clearTimeout(timeout);
    // 立即执行，此类情况一般用不到
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(function() {
        timeout = null;
      }, wait);
      if (callNow) typeof func === "function" && func();
    } else {
      // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
      timeout = setTimeout(function() {
        typeof func === "function" && func();
      }, wait);
    }
  }

  async queryFilter(query) {
    this.$nextTick(() => {
      this.Debounce(this.queryUser(query));
    });
  }

  async queryUser(query) {
    if (query) {
      this.data.filterWord = query;

      let queryStr = query.replace(/\(/g, "\\(").replace(/\)/g, "\\)");
      let reg = new RegExp(queryStr);
      let matchedUserList = this.selectList.filter((x) => x.displayText.match(reg));

      this.data.filterUserList = matchedUserList;
    }
  }

  loadMore(n) {
    //每次滚动到底部可以新增条数  可自定义
    this.data.rangeNumber += 5;
  }
  change(value) {
    this.$emit("on-change", value);
    // this.data.filterWord = "";
  }

  openChange(isOpen) {
    // if (isOpen) {
    //   this.data.filterWord = "";
    // }
  }
  clear() {
    this.data.filterWord = "";
    this.$emit("on-clear");
  }
}
